module.exports = __webpack_public_path__ + "img/bg_M2.cb756fd6.png";